<div class="result-button-container">
  <div
    ngbPopover="{{ 'Fokuskontrollpunkt' | translate }}"
    placement="top"
    triggers="mouseenter:mouseleave"
    [disablePopover]="!isFkp">
    <button
      class="btn btn-outline-primary btn-result"
      [ngClass]="{ focus: isFkp }"
      (click)="onChangeResult()"
      [disabled]="readonly">
      @if (result.inspectionResult === resultTypes.NotDefined) {
        <span>&nbsp;</span>
      }
      @if (!result.inspectionResult) {
        <span class="fas fa-check"></span>
      }
      @if (result.inspectionResult === resultTypes.Defect) {
        <span translate>M</span>
      }
      @if (result.inspectionResult === resultTypes.NotControlled) {
        <span translate>NK</span>
      }
      @if (result.inspectionResult === resultTypes.NotApplicable) {
        <span translate>NZ</span>
      }
    </button>
  </div>
  <div class="detail-result-remark-container">
    @if (
      result.inspectionResult === resultTypes.Defect ||
      result.inspectionResult === resultTypes.NotControlled ||
      result.inspectionResult === resultTypes.NotApplicable
    ) {
      <app-detail-result-remark
        class="btn-ellipsis-link-after-dropdown"
        [result]="result"
        (remarkChange)="onChangeRemark()"
        [readonly]="readonly"
        [elementName]="elementName"
        [defectDescriptionSuggestions]="defectDescriptionSuggestions"></app-detail-result-remark>
    }
  </div>
</div>
